module.exports = __webpack_public_path__ + "static/media/a-2.a11c0568.png";